document.addEventListener('DOMContentLoaded', function() {
    const questions = document.querySelectorAll('.faq-question');
    console.log(questions)
    questions.forEach((question) => {
        question.addEventListener('click', function() {
            const answer = this.nextElementSibling;
            const isActive = answer.classList.contains('active');
            const wrapper = this.closest('.faq-accordion-wrapper');
            
            if (isActive) {
                answer.classList.remove('active');
                answer.style.maxHeight = null;
                if (wrapper) wrapper.classList.remove('active');
            } else {
                answer.classList.add('active');
                answer.style.maxHeight = answer.scrollHeight + "px";
                if (wrapper) wrapper.classList.add('active');
            }
        });
    });
});